import isValid from 'date-fns/is_valid'
import emojiRegex from 'emoji-regex'
import _ from 'lodash'
import VeeValidate from 'vee-validate'
import Vue from 'vue'

// @ts-ignore
Vue.use(VeeValidate, {
  dictionary: {
    ja: {
      messages: {
        password: '半角英字、半角数字、どちらも使って8文字以上32文字以内入力してください。',
        tel_number: '電話番号に誤りがあります',
        unusable_character: '使用できない文字が含まれています',
        unusable_emoji: '絵文字は使用できません',
        contains_tab: 'タブ文字は使用できません',
      },
    },
  },
})

VeeValidate.Validator.extend('password', {
  getMessage() {
    return ''
  },
  validate: (value) => {
    const regex = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,32}$/i

    return regex.test(value)
  },
})

VeeValidate.Validator.extend('unusable_emoji', {
  getMessage() {
    return ''
  },
  validate: (value) => {
    const regex = emojiRegex()

    return !regex.test(value)
  },
})

VeeValidate.Validator.extend('unusable_character', {
  getMessage() {
    return ''
  },
  validate: (value) => {
    // TODO: バリデーションルールのモジュール化
    // 単体テストで色々なパターンを回したい。
    // 各ルールをモジュールとして独立させ、妥当な命名を適宜vee-validateに登録することで利用する形としたい。

    // TODO: ルール細分化
    // このルールが氏名/住所両方で使われているので、一部氏名で入力できるべきでないだろう記号文字（・_- 等）が入力可能となってしまう。
    // ルールをより最小限の規模に細分化し、必要なものを適宜組み合わせて利用できるようにする

    // TODO: 正規表現整理.
    // https://github.com/my-color/front/issues/1337
    //
    // 文字コードで制限すべき範囲を確認する.
    // 厳密に入力値を制限するのであれば、Unicode表を見て許可する文字/しない文字を吟味する必要がありそう.
    // そこまで厳密でなくて良いのであれば、多少記号が混ざってもそれなりに広い範囲で文字コードを指定するorそもそも文字コードで制限しない、が可能性として有り得る.
    //
    // 特に必要も無く厳密にすると、常用外の漢字や一部の記号等で、いくつか指定範囲から零れ落ちそう.
    //

    // Consoleで検索しやすくするため、ユーザからの入力としては全角の英数字・一部記号を許容しつつも、バックエンドで半角に変換し名寄せする。
    // https://github.com/my-color/front/issues/2320

    // tslint:disable-next-line
    const regex = /^[0-9０-９a-zA-Zａ-ｚＡ-Ｚ\s\-_・ー−　\u3005-\u3006\uFF21-\uFF9d\u3041-\u3096\u30A1-\u30FA\u3400-\u9FFF\uF900-\uFAFF]+$/

    return regex.test(value)
  },
})

VeeValidate.Validator.extend('contains_tab', {
  getMessage() {
    return ''
  },
  validate: (value) => {
    const regex = /\t/g

    return !regex.test(value)
  },
})

VeeValidate.Validator.extend('tel_number', {
  getMessage() {
    return ''
  },
  validate: (value) => {
    let valid = false

    const regexMobileNumber = /^090|^080|^070/
    const regexLengthMobile = /^.{11,11}$/
    const regexLengthOther = /^.{9,11}$/
    const isMobile = regexMobileNumber.test(value)

    if (isMobile) {
      valid = regexLengthMobile.test(value)
    } else {
      valid = regexLengthOther.test(value)
    }

    return valid
  },
})

export class UserValidator {

  public validateBirthday(
    year: number | null | undefined,
    month: number | null | undefined,
    day: number | null | undefined
    ): boolean {

    if (!year && !month && !day) return true
    if (!year || !month || !day) return false

    /**
     * FIXME
     * date-fns/isValidでは存在しない日付も通過できてしまうため、ほぼ数値さえ入っていればOKという状況。
     * ライブラリ側の修正はalpha版にしか入ってない: https://github.com/date-fns/date-fns/pull/808
     * 実装の経緯を確認の上、定義or実装を要修正
     */
    return isValid(new Date(year, month, day))
  }

  public validateIsSetUserNameAndKana(
    lastName: string | undefined,
    firstName: string | undefined,
    phoneticLastName: string | undefined,
    phoneticFirstName: string | undefined
  ): boolean {
    const username = (lastName && firstName) ? lastName + firstName : ''
    const usernameKana = (phoneticFirstName && phoneticLastName) ? phoneticLastName + phoneticFirstName : ''

    if (!this.validateRequiredUserName(lastName, firstName)) {
      return false
    }

    if (!this.validateRequiredUserNameKana(phoneticLastName, phoneticFirstName)) {
      return false
    }

    if (!_.isEmpty(username)) {
      return !_.isEmpty(usernameKana)
    }

    if (!_.isEmpty(usernameKana)) {
      return !_.isEmpty(username)
    }

    return true
  }

  public validateIsSetAddressAndTel(
    zipcode: string | undefined,
    prefecture: string | undefined,
    city: string | undefined,
    town: string | undefined,
    tel: string | undefined
  ): boolean {

    const address = _.toString(zipcode) + _.toString(prefecture) + _.toString(city) + _.toString(town)

    if (!this.validateRequiredAddress(zipcode, prefecture, city, town)) {
      return false
    }

    if (!_.isEmpty(address)) {
      return !_.isEmpty(tel)
    }

    if (!_.isEmpty(tel)) {
      return !_.isEmpty(address)
    }

    return true
  }

  public validateRequiredUserName(lastName: string | undefined, firstName: string | undefined): boolean {
    if (!_.isEmpty(lastName) || !_.isEmpty(firstName)) {
      return !_.isEmpty(lastName) && !_.isEmpty(firstName)
    }

    return true
  }

  public validateRequiredUserNameKana(
    phoneticLastName: string | undefined,
    phoneticFirstName: string | undefined
    ): boolean {
    if (
      !_.isEmpty(phoneticLastName) ||
      !_.isEmpty(phoneticFirstName)
    ) {
      return (
        !_.isEmpty(phoneticLastName) && !_.isEmpty(phoneticFirstName)
      )
    }

    return true
  }

  public validateRequiredAddress(
    zipcode: string | undefined,
    prefecture: string | undefined,
    city: string | undefined,
    town: string | undefined
  ): boolean {
    if (
      !_.isEmpty(zipcode) ||
      !_.isEmpty(_.toString(prefecture)) ||
      !_.isEmpty(city) ||
      !_.isEmpty(town)
    ) {
      return (
        !_.isEmpty(zipcode) &&
        !_.isEmpty(_.toString(prefecture)) &&
        !_.isEmpty(city) &&
        !_.isEmpty(town)
      )
    }

    return true
  }
}
